/* import __COLOCATED_TEMPLATE__ from './seller-posting-module.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { showModal } from "sh-www/utils/modal-controls";
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-seller-posting-module';
const MODULE_NOT_CLICKABLE_CLASS = `${CLASS_NAME}--not-clickable`;

class SellerPostingModule extends Component {
  @service router;

  #hasVerifiedProjectsCache = createCache(() => {
    return this.args.user?.projectdigests.toArray().some(({ confirm }) => confirm === true) ?? false;
  });

  #hasUnverifiableProjectsCache = createCache(() => {
    return this.args.user?.projectdigests.toArray().some(({ mostRecentProjectDigestVerification }) => mostRecentProjectDigestVerification?.status === -1) ?? false;
  });

  get hasVerifiedProjects() {
    return getValue(this.#hasVerifiedProjectsCache);
  }

  get hasUnverifiableProjects() {
    return getValue(this.#hasUnverifiableProjectsCache);
  }

  get moduleClasses() {
    return clsx(
      CLASS_NAME,
      this.hasVerifiedProjects && !this.args.user.isVetted && MODULE_NOT_CLICKABLE_CLASS,
    );
  }

  @action
  onClick() {
    const { user } = this.args;
    if (user.isVetted) {
      this.router.transitionTo('postings.find-work');
    } else if (!isEmpty(user.companySellerConnections)) {
      this.router.transitionTo('profile', user.slug);
    } else if (this.hasVerifiedProjects) {
      return;
    } else {
      showModal(this, 'work-samples/edit-verification-method', { projectdigests: user.projectdigests });
    }
  }
}

export default SellerPostingModule;
